import * as React from 'react';

// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = /*#__PURE__*/React.createContext(null)) : /*#__PURE__*/React.createContext(null);
var IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;

export { Context as C, Provider as P };
//# sourceMappingURL=injectIntl-BtqeBzQq-DKO65rGD.js.map
